export default "__VITE_ASSET__tWnkxLsL__"